<template>
  <div style="margin-bottom: 10px">
    <el-card class="box-card" style="margin-top: 3px">
      <el-form label-position="left" label-width="180px" size="mini">
        <!-- 统计数额的来源 -->
        <el-form-item label="统计数额的来源：">
          <el-radio-group v-model="data.amountSource">
            <el-radio v-for="item in availableAmountSources" :key="item.source" :label="item.source"
              :disabled="item.notYetImplemented">{{ item.text
              }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 统计数额的统计时间范围 -->
        <el-form-item label="统计数额的统计时间范围：">
          <el-radio-group v-model="data.amountTimeRangeType">
            <el-radio v-for="item in availableAmountTimeRangeTypes" :key="item.type" :label="item.type">{{ item.text
              }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 返利物品在哪里配置 -->
        <el-form-item label="返利物品在哪里配置：" prop="rebateItemIdConfigurePlace">
          <el-radio-group v-model="data.rebateItemIdConfigurePlace">
            <el-radio label="global">全局配置</el-radio>
            <el-radio label="rebateGears">在各返利档位中分别配置</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 返利哪种物品 -->
        <el-form-item v-if="data.rebateItemIdConfigurePlace == 'global'" label="返利哪种物品：" prop="rebateItemId">
          <el-select v-model="data.rebateItemId" filterable style="width: 450px">
            <el-option v-for="(item, key) in attachments" :key="key + $util.uuid()" :label="item"
              :value="parseInt(key)">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 返利邮件模板的Key -->
        <el-form-item label="返利邮件模板的Key：">
          <el-input v-model="data.rebateMailTemplateKey" placeholder="该Key引用自MailText表。仅当返利物品包含了除代币以外的东西时需要填写"
            style="width: 450px"></el-input>
        </el-form-item>

        <!-- 返利的发放时机 -->
        <el-form-item label="返利的发放时机：">
          <el-radio-group v-model="data.rebateChance">
            <el-radio v-for="item in availableRebateChances" :key="item.chance" :label="item.chance"
              :disabled="item.notYetImplemented">{{ item.text
              }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <div v-if="data.rebateChance != 'activityEnds'">
          <!-- 是否自动重置返利历史 -->
          <el-form-item label="自动重置返利历史：">
            <el-checkbox v-model="data.isAutoResetRebateHistory"></el-checkbox>
          </el-form-item>

          <!-- 返利历史自动重置策略 -->
          <el-form-item label="返利历史自动重置策略：" v-if="data.isAutoResetRebateHistory">
            <span>每天</span>
          </el-form-item>
        </div>
      </el-form>
    </el-card>

    <!-- 各个返利档位 -->
    <el-card class="box-card" style="margin-top: 3px">
      <div slot="header" class="clearfix">
        <span>返利档位</span>
        <el-button style="float: right" type="primary" icon="el-icon-plus"
          @click="openEditRebateGearDialog(true, null)">新增返利档位</el-button>
      </div>
      <el-form v-if="data.rebateItemIdConfigurePlace == 'global'" label-position="left" label-width="160px" size="mini">
        <!-- 返利档位里的返利物品数目的含义 -->
        <el-form-item label="返利物品数目的含义：" prop="rebateItemNumberType">
          <el-radio-group v-model="data.rebateItemNumberType">
            <el-radio label="number">字面数目</el-radio>
            <el-radio label="rate">比例（基于实际统计数额，而非基于档位数额）</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <el-table :data="data.rebateGears" border size="small" style="width: 551px; margin-top: 10px">
        <el-table-column prop="amount" label="统计数额达到" align="center" width="100" show-overflow-tooltip>
          <template scope="scope">
            {{ scope.row.amount }}
          </template>
        </el-table-column>
        <el-table-column v-if="data.rebateItemIdConfigurePlace == 'global'" show-overflow-tooltip prop="label"
          label="返利物品数目" align="center" width="350">
          <template scope="scope">
            <span>{{ scope.row.rebateItemNumber }}</span>
            <span v-if="data.rebateItemNumberType == 'rate'" style="color: red"> x 实际统计数额</span>
          </template>
        </el-table-column>
        <el-table-column v-else show-overflow-tooltip label="奖励" align="center" width="350">
          <template scope="scope">
            <ShowItems :items="scope.row.rewards" />
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" align="center" width="100">
          <template slot-scope="scope">
            <span class="link-button" style="color: red" @click="removeRebateGear(scope.$index)">删除</span>
            <span class="link-button" @click="openEditRebateGearDialog(false, scope.row, scope.$index)">编辑</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import ShowItems from "@/pages/activity/activity_parameter_template/components/ShowItems";
import { parse } from "uuid";

export default {
  data() {
    return {
      availableAmountSources: [
        {
          "source": "consumedFiat",
          "text": "消费的法币"
        },
        {
          "source": "purchasedCashTokens",
          "text": "购入的代币"
        },
        {
          "source": "consumedCashTokens",
          "text": "消费的代币",
        },
      ],
      availableAmountTimeRangeTypes: [
        {
          "type": "inActivity",
          "text": "仅活动期间"
        },
        {
          "type": "fromBorn",
          "text": "从出生开始"
        },
      ],
      availableRebateChances: [
        {
          "chance": "playerAsks",
          "text": "玩家请求"
        },
        {
          "chance": "immediately",
          "text": "立刻",
        },
        {
          "chance": "activityEnds",
          "text": "活动结束",
          "notYetImplemented": true, // 暂时还未实现
        },
      ],
      attachments: [],
      data: {
        rebateItemIdConfigurePlace: "global", // 返利哪种物品在哪里配置
        rebateItemId: "", // 返利哪种物品
        rebateMailTemplateKey: "", // 返利邮件模板的key
        amountSource: "consumedFiat", // 统计数额的来源
        amountTimeRangeType: "inActivity", // 统计数额的统计时间范围
        rebateItemNumberType: "number", // 返利档位里的返利物品数目的含义
        rebateChance: "playerAsks", // 发放返利的时机
        isAutoResetRebateHistory: false, // 是否自动重置返利历史
        rebateGears: [], // 各个返利档位
      },
    };
  },

  components: {
    ShowItems,
  },

  watch: {
    data: {
      async handler() {
        await this.updatedParam();
      },
      deep: true,
    },
  },

  async created() {
    if (this.parameter) {
      Object.assign(this.data, JSON.parse(this.parameter));

      // 有些字段要作处理
      if (this.data.rebateItemId === 0) {
        this.data.rebateItemId = "";
      }
    }

    this.attachments = await this.$bizutil.loadAttachments(false);
  },

  props: {
    parameter: "",
  },

  methods: {
    async openEditRebateGearDialog(isCreated, entry, index) {
      let that = this;
      this.$dialogutil.open("EditRebateGearDialog", {
        closedCallback: async (param) => {
          if (param != null) {
            if (isCreated) {
              that.data.rebateGears.push(param);
            } else {
              this.$set(that.data.rebateGears, index, param);
            }

            this.data.rebateGears.sort((x, y) => {
              return x.amount - y.amount;
            });

            await this.updatedParam();
          }
        },
        data: {
          rebateItemIdConfigurePlace: this.data.rebateItemIdConfigurePlace,
          rebateItemNumberType: this.data.rebateItemNumberType,
          isCreated: isCreated,
          entry: entry,
        },
      });
    },

    async removeRebateGear(index) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认删除充值达到数额为：${this.data.rebateGears[index].amount}的配置？`
        );
        this.data.rebateGears.splice(index, 1);

        await this.updatedParam();
      } catch (error) { }
    },

    async updatedParam() {
      let outputData = {};
      Object.assign(outputData, this.data);

      // 有些字段要作处理
      /*
      if (outputData.rebateItemId === "") {
        outputData.rebateItemId = 0;
      }
      */
      outputData.rebateItemId = parseInt(outputData.rebateItemId) || 0;

      this.$emit("updated", JSON.stringify(outputData), async () => {
        return;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.link-button {
  padding-left: 5px;
  padding-right: 5px;
  color: rgb(37, 148, 240);

  cursor: pointer;
}

/deep/ .el-table__row td {
  padding: 0px 0;
}

.el-table .cell.el-tooltip {
  white-space: normal;
}
</style>